import { FC } from 'react';
import MessageBar from '@groove/ui/Components/MessageBar';

import useStore from '../store/useStore';

/**
 * Moved out MessageBar as an optimization to prevent reloading of the whole react stack for changing messages
 * @returns MessageBar
 */

const MessageBarContainer: FC = () => {
  const messages = useStore(store => store.otherValues.messages);

  return <MessageBar messages={messages} />;
};

export default MessageBarContainer;
